/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lucky_Bald_Shrimp_BeamInputs */

const en_lucky_bald_shrimp_beam = /** @type {(inputs: Lucky_Bald_Shrimp_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const de_lucky_bald_shrimp_beam = /** @type {(inputs: Lucky_Bald_Shrimp_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Lucky_Bald_Shrimp_BeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lucky_bald_shrimp_beam = /** @type {((inputs?: Lucky_Bald_Shrimp_BeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lucky_Bald_Shrimp_BeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lucky_bald_shrimp_beam(inputs)
	return de_lucky_bald_shrimp_beam(inputs)
});